import { render, staticRenderFns } from "./TaskI.vue?vue&type=template&id=6bcf8bac&scoped=true"
import script from "./TaskI.vue?vue&type=script&lang=ts"
export * from "./TaskI.vue?vue&type=script&lang=ts"
import style0 from "./TaskI.vue?vue&type=style&index=0&id=6bcf8bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf8bac",
  null
  
)

export default component.exports